import { YoutubeLinkRepository } from '../../domain/repositories/youtube-link.repository.js';

export class DeleteYoutubeLinkUseCase {
  constructor(private readonly repository: YoutubeLinkRepository) {}

  public async execute(id: string): Promise<void> {
    return this.repository.delete(id);
  }
}
